export async function fetchBtcNasdaq({
  nasdaq = 'QQQ',
  btcPair = 'XXBTZUSD',
  btcEtp = 'IB1T.DE',
  btcSource = 'etp',
  range = '5Y',
  btcMethod = 'aligned_21utc',
} = {}) {
  const params = new URLSearchParams({
    nasdaq,
    btc_pair: btcPair,
    btc_etp: btcEtp,
    btc_source: btcSource,
    range,
    btc_method: btcMethod,
    include_bars: '1',
  });
  const response = await fetch(`/api/investing/btc-nasdaq?${params}`);
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok) {
    throw new Error(body?.error || `HTTP ${response.status}`);
  }
  return body;
}
